import { GetStaticProps } from 'next';
import { FranchiseListItem } from 'interfaces/content/Ranking';
import { HeaderNav } from 'interfaces/navigation/Header';
import PeopleRankingPage from 'pages/PeopleRanking/PeopleRankingPage';
import { Microsites } from 'constants/constants';
import handleStaticPropsError from 'utils/handleStaticPropsError';
import getFooter from 'api/Footer/getFooter';
import getFranchiseListItem from 'api/FranchiseChildPage/getFranchiseListItem';
import { setPianoConfig } from 'services/Piano';
import getMenu from 'api/Header/getMenu';
import { setHeadData } from 'utils/metaDataUtils/headData';
import setFranchisePageAdConfig from 'services/Ad/config/setFranchisePageAdConfig';
import { PageViewDataLayerObject } from 'services/Gtm/entities';
import setPageGtmConfig from 'services/Gtm/setPageGtmConfig';
import { setarcSpanPageConfig } from 'services/ArcSpan';
import { PreviewData } from 'interfaces/PreviewData';
import { safe, safeAsync } from 'utils/errorHandlingUtils';
import fallbackData from 'lib/fallbackData/commonData';

interface Props {
  item: FranchiseListItem;
}

const AsiaRankingDetail = ({ item }: Props) => (
  <PeopleRankingPage
    franchiseItem={item}
    trackingData={{
      eventAction: '',
      eventCategory: 'rankings',
      platformCD: Microsites.Asia,
    }}
  />
);

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const footer = await safeAsync(() => getFooter(), fallbackData.footer);
    const menu: HeaderNav = await safeAsync(
      () => getMenu('LEFT_MENU_COM', 'RIGHT_MENU_COM', 'TOPIC_NAVIGATION_COM', Microsites.Asia, null),
      fallbackData.headerNav,
    );

    const { previewData } = context as { previewData: PreviewData };
    const { franchiseSlug, year, id } = context.params as { franchiseSlug: string; year: string; id: string };
    const { franchiseListItem } = await getFranchiseListItem(
      `/${franchiseSlug}/${year}/${id}`,
      previewData,
      Microsites.Asia,
    );
    const headData = safe(() => setHeadData(franchiseListItem, false, 'Fortune Asia'), fallbackData.headData);

    const dataLayer: PageViewDataLayerObject = safe(() => setPageGtmConfig(franchiseListItem), fallbackData.dataLayer);
    const arcSpanPageConfig = safe(() => setarcSpanPageConfig(franchiseListItem), fallbackData.arcSpanPageConfig);
    const pianoPageConfig = safe(() => setPianoConfig(franchiseListItem, true), fallbackData.pianoPageConfig);
    const pageAdConfig = safe(() => setFranchisePageAdConfig(franchiseListItem), fallbackData.pageAdConfig);

    return {
      props: {
        arcSpanPageConfig,
        dataLayer,
        footer,
        headData,
        headerNav: menu,
        item: franchiseListItem,
        pageAdConfig,
        pianoPageConfig,
      },
      revalidate: 60,
    };
  } catch (error) {
    return handleStaticPropsError(error as Error);
  }
};

export const getStaticPaths = () => {
  if (process.env.TEST) {
    return {
      fallback: 'blocking',
      paths: [],
    };
  }

  return {
    fallback: 'blocking',
    paths: [], // TODO: FFD-5924: Update paths in getStaticPaths across the project
  };
};

export default AsiaRankingDetail;
